import React, {useEffect, useRef} from 'react';
import {Platform} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';

import {initRemoteConfig} from 'store/app/remoteConfigActions';
import {
  initDynamicLinkHandler,
  readAvatarParamsFromUrl,
  installAvatarSavedListener,
} from 'store/app/linkActions';
import {initCache} from 'store/app/cacheActions';
import {setCustomizerClosing} from 'store/app/actions';
import {setAvatarData} from 'store/appearance/actions';

const RemoteConfigHandler = () => {
  const dispatch = useDispatch();
  const isRemoteConfigLoaded = useSelector(
    (state) => state.app.isRemoteConfigLoaded,
  );
  const webDynamicLinkDispatchedRef = useRef(false);
  const webAvatarListenerInstalledRef = useRef(false);

  console.log('[WEBGL_DBG] InitializeAppData mount platform=' + Platform.OS);

  useEffect(() => {
    if (!isRemoteConfigLoaded) {
      console.log('[WEBGL_DBG] InitializeAppData: dispatching initRemoteConfig');
      dispatch(initRemoteConfig());
    } else {
      Platform.OS !== 'web' && dispatch(initDynamicLinkHandler());
      Platform.OS !== 'web' && dispatch(initCache());
    }
  }, [dispatch, isRemoteConfigLoaded]);

  // Web: gate initDynamicLinkHandler on Remote Config being loaded so token
  // validation runs against fetched integration_keys (not defaults). Use a ref
  // to ensure we only dispatch once.
  useEffect(() => {
    if (
      Platform.OS === 'web' &&
      isRemoteConfigLoaded &&
      !webDynamicLinkDispatchedRef.current
    ) {
      webDynamicLinkDispatchedRef.current = true;
      console.log(
        '[WEBGL_DBG] InitializeAppData: dispatching initDynamicLinkHandler (RC loaded)',
      );
      dispatch(initDynamicLinkHandler());
    }
  }, [isRemoteConfigLoaded, dispatch]);

  // Web: seed appearance from URL params on boot (so a refresh after avatar
  // save skips the customizer) and install a postMessage listener so future
  // saves persist the avatar id + skin tone to the URL too. No-op on native.
  useEffect(() => {
    if (Platform.OS !== 'web') return;
    if (webAvatarListenerInstalledRef.current) return;
    webAvatarListenerInstalledRef.current = true;

    const params = readAvatarParamsFromUrl();
    if (params) {
      console.log(
        '[WEBGL_DBG] InitializeAppData: seeding avatar from URL avatarId=' +
          params.avatarId +
          ' skinTone=' +
          (params.skinTone || 'null'),
      );
      dispatch(setAvatarData(params.avatarId, params.skinTone));
    }

    const unsubscribe = installAvatarSavedListener(
      dispatch,
      setAvatarData,
      setCustomizerClosing,
    );
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, [dispatch]);

  return <></>;
};

export default RemoteConfigHandler;
